import gql from 'graphql-tag';
import {COMPANY} from 'graphql/fragments/company';

export const GET_COMPANIES = gql`
  ${COMPANY}
  {
    getAllCompanies {
      ... on Error {
        message
        statusCode
      }
      ... on Company {
        ...company
      }
    }
  }
`;

// `getAllCompanyRecommendations` used to be selected here as well, which meant
// every page turn and every search keystroke re-fetched the recommendation list
// that `GET_ALL_COMPANY_RECOMMENDATIONS` already owns. The list page reads
// recommendations from that query alone now, so this one stays about companies.
export const GET_ALL_COMPANIES = gql`
  query GetAllAdminCompanies($filters: GetCompanyFilters) {
    getAllAdminCompanies(filters: $filters) {
      companies {
        id
        name
        legalName
        ticker
        stage
        isTrending
        logoImgURL
        totalCapitalRaised
        createdAt
      }
      totalDocs
      statistics {
        totalCompanies
      }
      totalPages
      hasPrevPage
      hasNextPage
      prevPage
      nextPage
    }
  }
`;

export const GET_ALL_COMPANY_RECOMMENDATIONS = gql`
  query GetAllCompanyRecommendations {
    getAllCompanyRecommendations {
      companyName
      websiteUrl
      user {
        id
        firstName
        middleName
        lastName
        imageUrl
      }
      isAdded
      id
    }
  }
`;

export const GET_USER_INVESTOR_UPDATE = gql`
  query GetUserInvestorUpdates($user: getUserInvestorUpdateInput) {
    getUserInvestorUpdates(user: $user) {
      ... on Error {
        message
        statusCode
      }
      ... on GetUserInvestorUpdatesType {
        investorUpdates {
          id
          title
          content
          keyTakeAway
          imageUrl
          topics {
            name
            imageUrl
          }
          companies {
            name
            imageUrl
          }
          countries {
            name
            imageUrl
          }
          assignedUsers
          publishedDate
          expirationDate
          isRead
        }
      }
    }
  }
`;

export const GET_COMPANY_BY_ID = gql`
  query GetCompany($companyId: ID!) {
    getCompany(companyId: $companyId) {
      ... on Error {
        message
        statusCode
      }
      ... on Company {
        id
        name
      }
    }
  }
`;
